import React from 'react';

import GongqiFormItem from './GongqiFormItem';

//Node的commonJS规范实现 import是ES6 node的这个规范与es6没有关系 将来要统一成ES6
//暂时先用Node的commonJS模块化实现类似于面向对象编程中静态工具类方法的效果
//const FormItemUtil = require("../utils/FormItemUtil");

class FormItemContainer extends GongqiFormItem
{
	constructor(props) 
	{
		super(props);
		this.containsMaxControl = this.containsMaxControl.bind(this);
	}

	//判断子级是否包含诸如Tab DataGrid HtmlPlugin等固定百分百控件
	containsMaxControl(item)
	{
		let children = item.FormItem;
		if(children == null || children == undefined)
			return false;
		for(var i=0;i<children.length;i++)
		{
			let child = children[i];
			if(child.type == "Tab" || child.type == "DataGrid" || child.type == "Plugin")
				return true;
			return this.containsMaxControl(child);
		}
		return false;
	}

	getStyle()
	{
		let layout = this.props.xml.Properties.Layout.Value;
		let parentLayout = this.props.parentLayout;
		let flexDirection = (layout=="horizontal"?"row":"column");
		let style = {
		  display:"flex",
		  alignSelf:"stretch"
	      //flex-direction:flexDirection,
	      //align-items:"flex-start",
	      //flex-grow:flexGrow
	    };
	    style["flexDirection"] = flexDirection;
	    style["alignItems"] = "flex-start";
	    let _containsMaxControl = this.containsMaxControl(this.props.xml);
	    if(parentLayout == "horizontal")
	    {
	    	//let json = JSON.stringify(this.props.xml.Properties.Width.Value);
	    	//alert(json);
	    	let _width = this.props.xml.Properties.Width.Value;
	    	if(_width == undefined)
	    		_width = "";
			let flexGrow = 0;
			let fixedWidth = false;
			if(_width == "" && _containsMaxControl)
			{
				flexGrow = 100;
			}
			else
			{
				let iex = _width.indexOf("%");
				if(iex!=-1)
				{
					flexGrow = _width.substring(0,iex);
				}
				
				if(iex==-1&&_width != "")
				{
					flexGrow = _width+"px";
					fixedWidth = true;
				}	
			}
			
			if(!fixedWidth)style["flexGrow"] = flexGrow; 

			let _height = this.props.xml.Properties.Height.Value;
			if(_height == undefined)
				_height = "";
			if(_height == "" && _containsMaxControl)
				_height = "100%";
			if(_height == "100%")
				style["alignSelf"] = "stretch";
			else if(_height.indexOf("%") != -1)
				style["height"] = _height;
			else if(_height != "")
				style["height"] = _height+"px";
	    }
	    else //vertical 暂不考虑absolute
	    {
	    	let _height = this.props.xml.Properties.Height.Value;
	    	if(_height==undefined)
	    		_height = "";
			let flexGrow = 0;
			let fixedHeight = false;
			if(_height == "" && _containsMaxControl)
			{
				flexGrow = 100;
			}
			else
			{
				let iex = _height.indexOf("%");
				if(iex!=-1)
				{
					flexGrow = _height.substring(0,iex);
				}
				if(iex==-1&&_height != "")
				{
					flexGrow = _height+"px";
					fixedHeight = true;
				}	
			}
			
			if(!fixedHeight)style["flexGrow"] = flexGrow; 

			let _width = this.props.xml.Properties.Width.Value;
			if(_width == undefined)
				_width = "";
			if(_width == "" && _containsMaxControl)
				_width = "100%";
			if(_width == "100%")
				style["alignSelf"] = "stretch";
			else if(_width.indexOf("%") != -1)
				style["width"] = _width;
			else if(_width != "")
				style["width"] = _width+"px";
	    }
		
		return style;
	}

	componentDidMount()
	{
		$(this.containerComponent).contextPopup(this.props.contextMenuData);
	}
};

FormItemContainer.defaultProps = {
};

export default FormItemContainer;


// WEBPACK FOOTER //
// ./src/formItem/FormItemContainer.js